import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import CustomerListView from 'src/views/customer/CustomerListView';
import DashboardView from 'src/views/reports/DashboardView';
import NotFoundView from 'src/views/errors/NotFoundView';
import ProductListView from 'src/views/product/ProductListView';
import Alerts from 'src/views/alerts/index';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'history', element: <CustomerListView /> },
      { path: 'devices', element: <DashboardView /> },
      { path: 'notification', element: <ProductListView /> },
      { path: '*', element: <Navigate to="/404" /> },
      { /* path: 'alerts', element: <Alerts /> */}, // Hide Modify Alert tab
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '404', element: <NotFoundView /> },
      { path: '/', element: <Navigate to="/app/notification" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
